import { Button, notification } from "antd";
import React, { useState } from "react";
import PasswordInput from "../form/password-input";
import { useNavigate } from "react-router-dom";
import DataProvider from "../../apis";

const PASSWORD_SPECIAL = /[@$!%*?&]/;

function getApiMessage(error: unknown): string {
  if (error && typeof error === "object" && "response" in error) {
    const res = (error as { response?: { data?: { message?: string } } }).response;
    if (res?.data?.message) return res.data.message;
  }
  if (error instanceof Error) return error.message;
  return "Sorry, we couldn't update your password. Please try again.";
}

function validateNewPassword(password: string): string | null {
  if (password.length < 8) return "Password must be at least 8 characters.";
  if (!/[A-Z]/.test(password)) return "Password must include at least one uppercase letter.";
  if (!/[a-z]/.test(password)) return "Password must include at least one lowercase letter.";
  if (!/[0-9]/.test(password)) return "Password must include at least one number.";
  if (!PASSWORD_SPECIAL.test(password)) return "Password must include at least one special character (@$!%*?&).";
  return null;
}

export default function ResetPassword2(props: any) {
  const navigate = useNavigate();
  const [api, contextHolder] = notification.useNotification();
  const [loading, setLoading] = useState(false);
  const [password, setPassword] = useState<string>("");
  const [confirmPassword, setConfirmPassword] = useState<string>("");

  const handleChangePassword = async () => {
    const passwordError = validateNewPassword(password);
    if (passwordError) {
      api.warning({ message: "Password", description: passwordError });
      return;
    }
    if (password !== confirmPassword) {
      api.warning({ message: "Password", description: "Passwords do not match." });
      return;
    }

    const email = (props.email || "").trim().toLowerCase();
    if (!email) {
      api.error({
        message: "Error",
        description: "Email is required. Please go back and verify your code again.",
      });
      return;
    }

    const payload = {
      email,
      token: String(props.otp ?? ""),
      newPassword: password,
    };

    setLoading(true);
    try {
      await DataProvider.resetPassword(payload);
      setLoading(false);
      api.success({
        message: "Success",
        description: (
          <span>
            Your password has been updated successfully.{" "}
            <Button type="link" className="p-0 h-auto font-semibold" onClick={() => navigate("/sign-in")}>
              Sign in
            </Button>
          </span>
        ),
      });
    } catch (error: unknown) {
      setLoading(false);
      api.error({
        message: "Failed",
        description: getApiMessage(error),
      });
    }
  };

  return (
    <div className="w-full md:h-[70vh] h-[50vh] flex flex-col justify-start items-start">
      {props.noBack ? null : (
        <Button onClick={() => props.setInnerTab(2)} className="my-2">
          Back
        </Button>
      )}
      <div className="w-full my-2 flex flex-col justify-center items-center p-4">
        <div className="md:w-[40%] w-full">
          <h3 className="font-semibold text-lg">Reset Password</h3>
          <p className="py-2">
            Enter your new password below. It must be at least 8 characters and
            include uppercase, lowercase, a number, and a special character (@$!%*?&).
          </p>

          <PasswordInput
            title="New Password"
            required
            password={password}
            setPassword={setPassword}
            placeholder="*****************"
          />

          <PasswordInput
            title="Confirm Password"
            required
            password={confirmPassword}
            setPassword={setConfirmPassword}
            placeholder="*****************"
          />

          <Button
            type="primary"
            onClick={handleChangePassword}
            className="bg-[#1A94EC] text-white hover:text-[#1A94EC]"
          >
            {loading ? "Saving..." : "Change password"}
          </Button>
          {props.noBack ? (
            <Button onClick={() => props.setInnerTab(1)} className="mx-2">
              Go Back
            </Button>
          ) : null}
        </div>
      </div>
      {contextHolder}
    </div>
  );
}
